export const FETCH_MAIN_CATEGORY_REQUEST = "FETCH_MAIN_CATEGORY_REQUEST";
export const FETCH_MAIN_CATEGORY_SUCCESS = "FETCH_MAIN_CATEGORY_SUCCESS";
export const FETCH_MAIN_CATEGORY_FAIL = "FETCH_MAIN_CATEGORY_FAIL";

export const UPDATE_MAIN_CATEGORY_REQUEST = "UPDATE_MAIN_CATEGORY_REQUEST";
export const UPDATE_MAIN_CATEGORY_SUCCESS = "UPDATE_MAIN_CATEGORY_SUCCESS";
export const UPDATE_MAIN_CATEGORY_FAIL = "UPDATE_MAIN_CATEGORY_FAIL";
















// export const FETCH_MAIN_CATEGORY_REQUEST = "FETCH_MAIN_CATEGORY_REQUEST";
// export const FETCH_MAIN_CATEGORY_SUCCESS = "FETCH_MAIN_CATEGORY_SUCCESS";
// export const FETCH_MAIN_CATEGORY_FAIL = "FETCH_MAIN_CATEGORY_FAIL";